export const messageConstants = {
	PUSH_NOTIFICATION: 'push_notification',
	MESSAGE: 'message',
}

export const messageKinds = {
	UNKNOWN: "unknown",
	INVITATION_UPDATE: "invitation_update",
	INVITATION: "invitation",
	COMPANY_MESSAGE: "company_message",
	MOD_MESSAGE: "mod_message"
}

export const messageAttachmentConstants = {
	EMPLOYEE_BOOKING_INVITATION: 'employee_booking_invitation',
	EMPLOYEE_BOOKING_INVITATION_SENT: 'employee_booking_INVITATION_SENT',
}
